import { renderConfiguracionPorTipo } from './RenderByType.js';
import { TIPOS_DATO } from './fieldTypes.js';

const FieldDefinition = ({ inicial, onChange, allSymptoms, sintomasPorPatologia }) => {
  const tipo = inicial?.tipo || TIPOS_DATO.NUMERICO;
  const config = inicial?.configuracion || {};
  const obligatorio = inicial?.obligatorio || false;

  // Handler para cuando cambia el tipo de dato
  const handleTipoChange = (e) => {
    const nuevoTipo = e.target.value;
    // Al cambiar el tipo, reseteamos la configuración específica de ese tipo
    onChange({
      tipo: nuevoTipo,
      configuracion: {}, // Configuración vacía para el nuevo tipo
      //obligatorio: obligatorio, // Mantenemos el valor de 'obligatorio'
    });
  };

  // Handler para cuando cambia la configuración del tipo de dato
  const handleConfigChange = (nuevaConfig) => {
    onChange({
      tipo: tipo,
      configuracion: nuevaConfig,
      obligatorio: obligatorio,
    });
  };

  // Handler para cuando cambia el checkbox 'obligatorio'
  const handleObligatorioChange = (e) => {
    onChange({
      tipo: tipo,
      configuracion: config,
      obligatorio: e.target.checked,
    });
  };

  return (
    <div className="card p-3">
      <div className="mb-3">
        <label className="form-label">Tipo de dato</label>
        <select
          className="form-select"
          value={tipo}
          onChange={handleTipoChange}
        >
          <option value={TIPOS_DATO.NUMERICO}>Numérico {/* (ej: temperatura) */}</option>
          <option value={TIPOS_DATO.BOOLEANO}>Si/No {/* (ej: presente/ausente) */}</option>
          <option value={TIPOS_DATO.SELECCION}>Selección única {/* (ej: leve/moderado/grave) */}</option>
          <option value={TIPOS_DATO.MULTIPLE}>Selección múltiple {/* (ej: síntomas presentes) */}</option>
          {/* <option value={TIPOS_DATO.RANGO}>Rango predefinido</option> */}
          {/* <option value={TIPOS_DATO.ESCALA}>Escala numérica </option> */}
          <option value={TIPOS_DATO.TEXTO}>Texto libre {/* (ej: observaciones) */}</option>
          <option value={TIPOS_DATO.FECHA}>Fecha {/* (ej: inicio síntomas) */}</option>
          <option value={TIPOS_DATO.DURACION}>Duración {/* (ej: tiempo con síntoma) */}</option>
          <option value={TIPOS_DATO.COMPUESTO}>Compuesto {/* (ej: PPD con múltiples lecturas) */}</option>
        </select>
      </div>

      {/* Pasamos handleConfigChange a los componentes hijos */}
      {renderConfiguracionPorTipo(handleConfigChange, tipo, config, allSymptoms, sintomasPorPatologia)}

      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          checked={obligatorio}
          onChange={handleObligatorioChange}
        />
        <label className="form-check-label">Obligatorio</label>
      </div>
    </div>
  );
};

export default FieldDefinition;
